import gsap from "gsap";
import config from "../config";


const tl = gsap.timeline({ paused: true, reversed: true, defaults:{ ease: "power1", duration: 0.5 } });

const Navbar = (button, menu) => {
  if (window.innerWidth <= config.breakpointSM){
    NavbarToggleClick(button, menu);
  } else {
    NavbarAnimation({menu, delay: 1});
  }
} 

const NavbarAnimation = ({menu, delay = 0}) => {
  const navbarTl = gsap.timeline({defaults:{ ease: "power1", duration: 0.5 }, delay: delay});
  const subline = menu.querySelector(".site-header__subline"),
        navItems = [...menu.querySelectorAll(".navbar__link")],
        footer = menu.querySelector(".site-footer");
  
  navbarTl.from(subline, {
    opacity: 0,
    x: 50,
    duration: 1.5
  })
  .from(navItems, {
    opacity: 0,
    stagger: (navItems.length / 10) / navItems.length,
    duration: navItems.length / 10
  }, "-=1.5")
  .from(footer, {
    opacity: 0,
    x: 50,
    duration: 1
  }, "-=0.75")

  return navbarTl;
}

const NavbarToggleClick = (button, menu) => {
  button.addEventListener("click", () => NavbarToggleTimeline(button));

  tl.to(menu, { 
    opacity: 1,
    display: "block"
  })
  .add(NavbarAnimation({menu}))
}
 
const NavbarToggleTimeline = (button) => {
    if (tl.reversed()) {
      tl.timeScale(1).play();
      button.classList.add("is-active");
    } else {
      tl.timeScale(3).reverse();
      button.classList.remove("is-active");
    }
  } 

export default Navbar